// Check if num is a finite number withtout type conversion
// http://stackoverflow.com/a/825482
export default function isNotaFiniteNumber(num?: number | string | null) {
  return typeof num !== 'number' || !isFinite(num)
}
